<script setup>
defineProps({
  noPadding: Boolean,
})
</script>

<template>
  <div
    class="relative flex w-full flex-col rounded-md bg-white shadow-3xl md:w-auto overflow-auto"
  >
    <div
      v-if="$slots.head"
      class="flex flex-col p-4 sm:flex-row sm:items-center md:px-8 md:pt-8"
    >
      <div
        class="mr-4 mb-0 flex flex-1 flex-col text-base font-bold leading-4 tracking-tight text-grey-500"
      >
        <slot name="head" />
      </div>

      <div
        v-if="$slots['head-right']"
        class="mt-2 flex items-center justify-end space-x-2 sm:mt-0"
      >
        <slot name="head-right" />
      </div>
    </div>

    <div
      class="flex flex-1 flex-col"
      :class="{ 'p-0': noPadding, 'px-4 pb-4 md:px-8 md:pb-8': !noPadding }"
    >
      <slot />
    </div>
  </div>
</template>
